import React from 'react'
import { Score as ScoreI } from 'types/global'
import styles from 'components/generic/styles/score.module.scss'

interface Props {
  score: ScoreI
}

const Score = ({ score }: Props) => {
  const { sets, superTiebreak } = score || {}
  if (!sets) return null
  return (
    <span className={styles.scores}>
      {sets.map((s, index) => {
        let winnerTiebreak
        let loserTiebreak

        if (s.tiebreaker) {
          const { loserPointsWon, winnerPointsWon } = s.tiebreaker

          if (s.winnerGamesWon === null)
            return (
              <span key={index} className={styles.set}>
                [{winnerPointsWon}-{loserPointsWon}]{index !== sets.length - 1 && ','}
              </span>
            )

          if (winnerPointsWon > loserPointsWon) {
            loserTiebreak = loserPointsWon
          } else {
            winnerTiebreak = winnerPointsWon
          }
        }

        return (
          <span key={index} className={styles.set}>
            {s.winnerGamesWon}
            {typeof winnerTiebreak === 'number' && <sup>{winnerTiebreak}</sup>}-{s.loserGamesWon}
            {typeof loserTiebreak === 'number' && <sup>{loserTiebreak}</sup>}
            {(index !== sets.length - 1 || superTiebreak) && ','}
          </span>
        )
      })}
      {superTiebreak && (
        <span className={styles.set}>
          {`[${superTiebreak.winnerPointsWon}-${superTiebreak.loserPointsWon}]`}
        </span>
      )}
    </span>
  )
}

export default Score
